import { motion } from "framer-motion";
import { occasionImgs } from "../../data/site";
import { fadeUp } from "../../lib/motion";
import { useLanguage } from "../../lib/i18n";

export const Occasions = () => {
  const { t } = useLanguage();
  const items = t("occasions.items");

  return (
    <section id="occasions" data-testid="occasions-section" className="tiled relative py-8 md:py-12 bg-[--bg-2]">
      <div className="max-w-[1600px] mx-auto px-5 md:px-10">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {items.map((o, i) => (
            <motion.div key={i} variants={fadeUp} custom={i} initial="hidden" whileInView="visible" viewport={{ once: true, margin: "-60px" }} className="group relative overflow-hidden rounded-2xl border border-[--olive] aspect-[4/5]">
              <img src={occasionImgs[i]} alt={o.title} className="photo-grade absolute inset-0 w-full h-full object-cover scale-100 group-hover:scale-105 transition-transform duration-[900ms] ease-[cubic-bezier(0.16,1,0.3,1)]" />
              <div className="absolute inset-0 bg-gradient-to-t from-[#14180E] via-[#14180E]/40 to-transparent" />
              <div className="absolute bottom-0 left-0 right-0 p-7">
                <h3 className="font-display text-2xl text-[--text] mb-2">{o.title}</h3>
                <p className="text-[--text-2] text-sm leading-relaxed">{o.body}</p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
